import * as React from 'react'
import { Routes, Route } from 'react-router-dom'
import Livros from '../pages/livros/livros'
import Postagem from '../pages/postagens/postagens'
import Cadastro from '../pages/postagens/Cadastro'
import Emprestimo from '../pages/emprestimo'
import Sugestao from '../pages/sugestao'
import ColaboradorDashBoard from '../pages/dashboardColaborador'
import AutoEmprestimo from '../pages/autoEmprestimo'
import PrivateRoute from './PrivateRoute'
import Exemplar from '../pages/exemplar'
import Reserva from '../pages/reserva'
import DashboardMultiplo from '../pages/dashboard/DashboardMultiplo'
import Bibliotecario from '../pages/bibliotecario'
import Gestor from '../pages/gestor'
import Leitor from '../pages/leitor'
import Logs from '../pages/logs'
import QrCodePage from '../pages/qrcode'
import ForbidenPage from '../pages/error/forbiden'
import InternalError from '../pages/error/500'
import AccessErrorPage from '../pages/error/accessError'
import RelatoriosPage from '../pages/relatorios'
import { any } from 'prop-types'
import NotFoundError from '../pages/error/404'

const ClearLayout = ({ children }) => {
  return <>{children}</>
}
ClearLayout.propTypes = {
  children: any
}
const routes = [
  {
    path: '/',
    page: DashboardMultiplo,
    private: true
  },
  {
    path: '/livros',
    page: Livros,
    private: true
  },
  { path: '/leituras', page: Postagem, private: true },
  // { path: '/postagens/cadastro/:idPostagem', page: Cadastro, private: true },
  {
    path: '/leituras/cadastro/',
    page: Cadastro,
    private: true
  },
  { path: '/emprestimo', page: Emprestimo, private: true },
  { path: '/reservas', page: Reserva, private: true },
  { path: '/sugestao', page: Sugestao, private: true },
  {
    path: '/dashboard',
    page: ColaboradorDashBoard,
    private: true
  },
  {
    path: '/autoemprestimo',
    page: AutoEmprestimo,
    private: true
  },
  {
    path: '/livro/:idObra/&name::obraName',
    page: Exemplar,
    private: true
  },
  {
    path: '/bibliotecario',
    page: Bibliotecario,
    private: true
  },
  {
    path: '/gestor',
    page: Gestor,
    private: true
  },
  { path: '/leitor', page: Leitor, private: true },
  { path: '/logs', page: Logs, private: true },
  {
    path: '/forbiden',
    page: ForbidenPage,
    private: false
  },
  {
    path: '/erro-interno',
    page: InternalError,
    private: true
  },
  {
    path: '/erro-permissoes',
    page: AccessErrorPage,
    private: true
  },
  {
    path: '/relatorio',
    page: RelatoriosPage,
    private: true
  },
  {
    path: '/qrcode',
    page: QrCodePage,
    private: true
  }
]

const Rotas = () => {
  return (
    <Routes>
      {routes.map((item, index) => {
        const Page = () => {
          return <item.page />
        }
        const Element = () =>
          item.private === true ? (
            <PrivateRoute>
              <Page />
            </PrivateRoute>
          ) : (
            <Page />
          )
        return (
          <Route
            key={index}
            exact
            path={`${process.env.PUBLIC_URL}${item.path}`}
            element={<Element />}
          />
        )
      })}
      <Route path={`${process.env.PUBLIC_URL}/*`} element={<NotFoundError />} />
    </Routes>
  )
}

export default Rotas
